import { render, staticRenderFns } from "./customer-info-notes-card.vue?vue&type=template&id=112e993b"
import script from "./customer-info-notes-card.vue?vue&type=script&lang=js"
export * from "./customer-info-notes-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports